export default function ProspectsTableCRM({ prospects, search, onBack, onEnrichSingle }) {
  const handleEnrich = (contactId, type) => {
    const options = {
      emailOnly: type === 'email',
      phoneOnly: type === 'phone',
      both: type === 'both',
    }
    onEnrichSingle?.(contactId, options)
  }

  return (
    <div className="history-crm-section">
      <div className="crm-header">
        <button className="back-to-history-btn" onClick={onBack} type="button">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          Retour à l'historique
        </button>
        <div className="crm-header-info">
          <h3>{search.query}</h3>
          <p>
            {search.totalResults?.toLocaleString() || 0} résultats • {prospects.length} aperçus
          </p>
        </div>
      </div>

      <div className="crm-table-container">
        <table className="crm-prospects-table">
          <thead>
            <tr>
              <th>Nom</th>
              <th>Poste</th>
              <th>Entreprise</th>
              <th>Localisation</th>
              <th>Email</th>
              <th>Téléphone</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {prospects.map((prospect, index) => {
              const contactId = search.availableContactIds?.[index]
              const hasEmail = prospect.email || prospect.primaryEmail
              const hasPhone = prospect.phone || prospect.phoneNumber

              return (
                <tr key={index} data-contact-id={contactId}>
                  <td>
                    <div className="prospect-name-cell">
                      <div className="prospect-avatar-mini">
                        {(prospect.firstName?.charAt(0) || '') + (prospect.lastName?.charAt(0) || '')}
                      </div>
                      <span>
                        {prospect.firstName || ''} {prospect.lastName || ''}
                      </span>
                    </div>
                  </td>
                  <td>{prospect.jobTitle || '-'}</td>
                  <td>{prospect.Company_name || prospect.companyName || '-'}</td>
                  <td>{prospect.location || prospect.country || '-'}</td>
                  <td>
                    <span className={`email-status ${hasEmail ? 'has-email' : 'no-email'}`}>
                      {hasEmail || 'Non disponible'}
                    </span>
                  </td>
                  <td>
                    <span className={`phone-status ${hasPhone ? 'has-phone' : 'no-phone'}`}>
                      {hasPhone || 'Non disponible'}
                    </span>
                  </td>
                  <td>
                    <div className="crm-actions">
                      <button
                        className="crm-action-btn enrich-email-btn"
                        onClick={() => handleEnrich(contactId, 'email')}
                        title="Enrichir email (2 crédits)"
                        type="button"
                      >
                        <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
                          <path
                            d="M2 4L8 9L14 4M2 4V12H14V4"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                      <button
                        className="crm-action-btn enrich-phone-btn"
                        onClick={() => handleEnrich(contactId, 'phone')}
                        title="Enrichir téléphone (2 crédits)"
                        type="button"
                      >
                        <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
                          <path
                            d="M3 2C3 2 5 3 6 5C7 7 6 8 6 8C6 8 7 9 9 11C11 13 12 12 12 12C12 12 13 11 15 12C17 13 14 14 14 14C13 14 9 13 6 10C3 7 2 3 2 2C2 2 3 2 3 2Z"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                      <button
                        className="crm-action-btn enrich-both-btn"
                        onClick={() => handleEnrich(contactId, 'both')}
                        title="Enrichir tout (2 crédits)"
                        type="button"
                      >
                        <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
                          <path d="M8 2L10 6L14 8L10 10L8 14L6 10L2 8L6 6L8 2Z" fill="currentColor" />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}
